import { Box, Title, Text, Group, Stack, Paper } from "@mantine/core";
import NavigationArrowIcon from "@/assets/icons/NavigationArrowIcon";
import { accentDividerStyle, patternedLeftAccentCardProps } from "@canucci/base-mantine/theme";
import { OverviewCardProps } from "./types";
import styles from "./OverviewCard.module.css";
import { focusBackgroundAtIndex } from "@/utils/focusPatterns";

function OverviewStandardCard(props: OverviewCardProps) {
  const { title, description, groupIndex, icon, onClick } = props;
  const textColor = "var(--text-on-dark)";
  const patternCardProps = patternedLeftAccentCardProps(focusBackgroundAtIndex(groupIndex), groupIndex);

  return (
    <Paper
      {...patternCardProps}
      className={styles.standardCard}
      p="calc(var(--mantine-spacing-md) + var(--mantine-spacing-lg) + 1px)"
      h="100%"
      onClick={onClick}
    >
      <Group justify="space-between" align="center" wrap="nowrap" gap="md" h="100%">
        <Stack className={styles.standardCardContent} gap="xs">
          <Title size="h1" c={textColor} w="100%">
            {title}
          </Title>
          <Box style={accentDividerStyle} mb="sm" />
          <Text c="var(--text-on-dark)" lh="1.4">
            {description}
          </Text>
          {icon}
        </Stack>
        <Box className={styles.standardCardArrow}>
          <NavigationArrowIcon direction="right" color={textColor} />
        </Box>
      </Group>
    </Paper>
  );
}

export default OverviewStandardCard;
